import { render, staticRenderFns } from "./RegionCascader.vue?vue&type=template&id=d25012f6&scoped=true"
import script from "./RegionCascader.vue?vue&type=script&lang=js"
export * from "./RegionCascader.vue?vue&type=script&lang=js"
import style0 from "./RegionCascader.vue?vue&type=style&index=0&id=d25012f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25012f6",
  null
  
)

export default component.exports